import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=3f2b3be0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f2b3be0"]])

export default __exports__